import { PropertyFinancialsModel } from './../models/propertyFinancialsModel';
import { PropertyCardModel } from './../models/propertyCardModel';
import { PropertyDetailsModel } from './../models/propertyDetailsModel';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../data.service';
import { PropertyDocumentModel } from '../models/PropertyDocumentModel';

@Component({
  selector: 'app-summarysheet1',
  templateUrl: './summarysheet1.component.html',
  styleUrls: ['./summarysheet1.component.scss']
})
export class Summarysheet1Component implements OnInit {


  public ownersname :string[] = new Array();
  public salesdeeddate : number;
  public stampdutydate : number;
  public planapprovaldate : number;
  public propertytypename : string = "";
  public propertyarea : string = "";
  public propertyaddress : string[] = new Array();
  public localauthoritydoc : string = "";
  public propertydescription : string = "";
  public surveynumber : string = "";
  public area : string = "";
  public value : string;

  public financials : PropertyFinancialsModel;

  public stampdutydocs : Array<PropertyDocumentModel>;
  

  constructor(private data: DataService,private router: Router) { }

  ngOnInit(): void {
    
    this.financials = this.data.SelectedProperty.propertyfinancials;
    this.data.SelectedProperty.owners.forEach(o => {
        this.ownersname.push(o.name);
    });
    this.salesdeeddate = this.data.SelectedProperty.propertydocuments.find(x => x.category == 7)?.documentdate;
    this.stampdutydate = this.data.SelectedProperty.propertydocuments.find(x => x.category == 7)?.documentdate;
    this.planapprovaldate = this.data.SelectedProperty.propertydocuments.find(x => x.category == 10)?.documentdate;
    this.propertytypename = this.data.PropertyTypes.find(x => x.PropertyTypeCode == this.data.SelectedProperty.propertydetails.propertytype).PropertyTypeName;
    this.propertyarea = this.data.SelectedProperty.propertydetails.areainsqmtr + " Sq. Mtr.";
    this.propertyaddress.push(this.data.SelectedProperty.propertydetails.buildingname);
    this.propertyaddress.push(this.data.SelectedProperty.propertydetails.streetname);
    this.propertyaddress.push(this.data.SelectedProperty.propertydetails.locality);
    this.propertyaddress.push(this.data.SelectedProperty.propertydetails.landmark);
    this.propertyaddress.push(this.data.SelectedProperty.propertydetails.roadname);
    this.propertyaddress.push('Village: ' + this.data.SelectedProperty.propertydetails.village);
    this.propertyaddress.push('Town: ' + this.data.SelectedProperty.propertydetails.town);
    this.propertyaddress.push('City: ' + this.data.SelectedProperty.propertydetails.city);
    this.propertyaddress.push('District: ' + this.data.SelectedProperty.propertydetails.district);
    this.propertyaddress.push('State: ' + this.data.SelectedProperty.propertydetails.state);
    this.propertyaddress.push('Country: ' + this.data.SelectedProperty.propertydetails.country);
    this.propertyaddress.push('Pincode: ' + this.data.SelectedProperty.propertydetails.pincode);

    this.stampdutydocs = this.data.SelectedProperty.propertydocuments.filter(x => x.category == 4).sort((a,b) => b.documentdate - a.documentdate).slice(0,3);

    this.propertydescription = this.data.SelectedProperty.propertydetails.propertydescription;
    this.surveynumber = this.data.SelectedProperty.propertydetails.surveynumber;

    if (this.data.SelectedProperty.propertydetails.area1 > 0){
      this.area = this.data.SelectedProperty.propertydetails.area1 + ' ' + this.data.SelectedProperty.propertydetails.area1unit;
    }
    if (this.data.SelectedProperty.propertydetails.area2 > 0){
      this.area += '  ' + this.data.SelectedProperty.propertydetails.area2 + ' ' + this.data.SelectedProperty.propertydetails.area2unit;
    }
    if (this.data.SelectedProperty.propertydetails.area3 > 0){
      this.area += '  ' + this.data.SelectedProperty.propertydetails.area3 + ' ' + this.data.SelectedProperty.propertydetails.area3unit;
    }

    this.value = this.data.SelectedProperty.propertyfinancials.currentmarketvalue.toString();

  }

  onEmail() : boolean {
    this.router.navigate(['summarymailprogress']);
    return false;
  }

  onWhatsapp() : boolean {
    this.router.navigate(['summarymessageprogress']);
    return false;
  }

}
